export type BuyerTestimonial = {
  quote: string;
  author: string;
  initials: string;
  location: string;
  photo?: string;
};

export type LookbookImage = {
  src: string;
  fallbackSrc: string;
  alt: string;
};

export const buyerTestimonials: BuyerTestimonial[] = [
  {
    quote:
      "Print came out sharp and the tee feels thick—no cheap POD texture.",
    author: "Amina",
    initials: "AS",
    location: "Casablanca",
    photo:
      "https://i.pinimg.com/1200x/25/0a/86/250a86fb74e69a1b6b05b9b9f1f02b4a.jpg",
  },
  {
    quote:
      "The fit is clean and the colors look like the preview. That's rare.",
    author: "Youssef",
    initials: "YB",
    location: "Rabat",
    photo:
      "https://i.pinimg.com/1200x/4e/0f/1e/4e0f1e9e29d87b3b78b1d6dbfd3b2cc0.jpg",
  },
  {
    quote:
      "Hoodie feels premium. Stitching is neat and the print isn't rubbery.",
    author: "Salma",
    initials: "SL",
    location: "Marrakech",
    photo:
      "https://i.pinimg.com/1200x/64/54/b3/6454b35b8f59b0d9b23b0e1c5f0d6d7a.jpg",
  },
  {
    quote:
      "Fast support, easy exchange. The whole experience felt high-end.",
    author: "Omar",
    initials: "OT",
    location: "Tangier",
    photo:
      "https://i.pinimg.com/1200x/8c/52/11/8c5211b8a4a8f3c4b0e5f92b3b3d7e34.jpg",
  },
  {
    quote:
      "Looks expensive in person. The kind of piece people ask about.",
    author: "Khadija",
    initials: "KT",
    location: "Fes",
    photo:
      "https://i.pinimg.com/1200x/0d/9b/77/0d9b77e6d9d75d9e8ff1ec651c0a53b2.jpg",
  },
  {
    quote:
      "Packaging was clean and the print is super crisp. I'm ordering again.",
    author: "Nabil",
    initials: "NA",
    location: "Agadir",
    photo:
      "https://i.pinimg.com/1200x/ba/0e/7b/ba0e7b6bd0d9a8f4e8ef7b6b6e2b7c22.jpg",
  },
];

export const sellerTestimonial = {
  quote:
    "I uploaded on Friday and had my first sale by Sunday. No inventory, no stress — just my designs live.",
  author: "Layla M.",
  role: "Independent designer, Casablanca",
};

export const lookbookImages: LookbookImage[] = [
  {
    src: "https://i.pinimg.com/1200x/c0/a7/be/c0a7be3d7ee7d6ee51f7ac3880e5e5e5.jpg",
    fallbackSrc: "/assets/t-shirt-white-mockup.png",
    alt: "Premium lookbook — studio fit",
  },
  {
    src: "https://i.pinimg.com/736x/f4/8f/11/f48f118359871b62d44c0bafe9cf4961.jpg",
    fallbackSrc: "/assets/t-shirt-black-mockup.png",
    alt: "Premium lookbook — street style",
  },
  {
    src: "https://i.pinimg.com/1200x/68/fe/f8/68fef885052e09d6a6446269f8b55404.jpg",
    fallbackSrc: "/assets/t-shirt-workspace.png",
    alt: "Premium lookbook — design workspace",
  },
  {
    src: "https://i.pinimg.com/1200x/90/ba/2b/90ba2b569a6cf0d67d76a2af13f574b8.jpg",
    fallbackSrc: "/assets/tshirts/white-tshirt-front.png",
    alt: "Premium lookbook — clean tee",
  },
  {
    src: "https://i.pinimg.com/1200x/bd/bc/89/bdbc893332d71b330f571ce631f8b766.jpg",
    fallbackSrc: "/assets/tshirts/white-tshirt-back.png",
    alt: "Premium lookbook — back print",
  },
  {
    src: "https://i.pinimg.com/1200x/b3/6e/6c/b36e6c00c6d8c5a3ab167c4266808450.jpg",
    fallbackSrc: "/assets/tshirts/black-tshirt-front.png",
    alt: "Premium lookbook — black tee",
  },
];

export const productionSteps = [
  {
    step: "Design",
    description: "Curated in Morocco — limited drops, not endless catalogs.",
  },
  {
    step: "Print",
    description: "Premium inks on thick blanks. QC before anything ships.",
  },
  {
    step: "Ship",
    description: "Tracked delivery to Morocco and international destinations.",
  },
];
